module.exports = __webpack_public_path__ + "static/media/centro.d804cf52.jpg";